<ng-container *ngIf="!(isPartOfArNavigation$  | async)">
    <div class="alert alert-danger">{{ 'aumico_reports_page_is_not_part_of_ar_navigation' | i18next }}</div>
</ng-container>
<ng-container *ngIf="(isPartOfArNavigation$  | async)" content [ngSwitch]="dataState">
    <mat-tab-group
        *ngSwitchCase="'success'"
        class="adjustment-and-reclasses"
        (selectedTabChange)="handleChangeOfTabs($event)"
    >
        <mat-tab label="{{ localizationKeys.aumico_reports_annualreport_navigation_label_balance | i18next }}">
            <adjustments-reclasses-form-component
                [language]="currentLanguage"
                [defaultLanguage]="defaultLanguage"
                [engine]="balanceEngine"
                [currency]="currency"
                (copiedBalanceChangeInAdjustmentsToIncomeAdjustment)="copyChangeInAdjustmentsToIncomeAccount($event)"
                [wordBeforeCurrencyKey]="wordBeforeCurrencyKey"
                [totalWordKey]="totalWordKey"
                [shouldRecalculate]="false"
                [templateRowIdToRowChildrenIds]="templateRowIdToRowChildrenIdsForBalance"
                [templateRowIdToParentsIds]="templateRowIdToRowParentsIdsForBalance"
                [readonlyReclasses]="readonlyReclasses"
            >
            </adjustments-reclasses-form-component>
        </mat-tab>
        <mat-tab label="{{ localizationKeys.aumico_reports_annualreport_navigation_label_income | i18next }}">
            <adjustments-reclasses-form-component
                [language]="currentLanguage"
                [defaultLanguage]="defaultLanguage"
                [engine]="incomeEngine"
                [currency]="currency"
                [wordBeforeCurrencyKey]="wordBeforeCurrencyKey"
                [totalWordKey]="totalWordKey"
                [shouldRecalculate]="shouldIncomeRecalculate"
                [templateRowIdToRowChildrenIds]="templateRowIdToRowChildrenIdsForIncome"
                [templateRowIdToParentsIds]="templateRowIdToRowParentsIdsForIncome"
                [readonlyReclasses]="readonlyReclasses"
            >
            </adjustments-reclasses-form-component>
        </mat-tab>
    </mat-tab-group>

    <div *ngSwitchCase="'error'" class="alert alert-danger">
        {{ 'aumico_reports_required_data_not_completed' | i18next }}

        <aum-form-error *ngIf="isBackendReturnError">
            <span>{{ backendErrors | i18next}} </span>
        </aum-form-error>
    </div>
    <div *ngSwitchDefault class="alert alert-danger">UNKNOWN STATE</div>
</ng-container>
<ng-template #footerTemplate>
    <aum-action-bar-pure
        [extraActionButtons]="footerExtraButtonActions"
        nextButtonPrefixText="{{nextStepPrefix | i18next}}"
        nextButtonText="{{nextStepLabel | i18next}}"
        nextButtonRouterLink="../{{nextStepPath}}"
        [nextButtonAction]="proceedButtonClicked"
        [nextButtonDisabled]="disableProceedButton"
        backButtonPrefixText="{{previousStepPrefix | i18next}}"
        backButtonText="{{previousStepLabel | i18next}}"
        backButtonRouterLink="../{{previousStepPath}}"
        [backButtonIcon]="previousStepIcon"
    ></aum-action-bar-pure>
</ng-template>
